var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import memoize from 'fast-memoize';
export function _getCreative(config, id, language, size) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = new URL(`${config.creativeApiHost}/creative`);
        url.searchParams.set('customer', config.customer);
        url.searchParams.set('id', id);
        url.searchParams.set('language', language);
        url.searchParams.set('size', size);
        url.searchParams.set('fallbackLanguage', config.defaults.language);
        try {
            const response = yield fetch(url.toString());
            if (response.ok) {
                return (yield response.json()).url;
            }
            else {
                return null;
            }
        }
        catch (e) {
            console.error(e);
            return null;
        }
    });
}
export const getCreative = memoize(_getCreative);
export function _getCreativeIds(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const url = new URL(`${config.creativeApiHost}/creativeIds`);
        url.searchParams.set('customer', config.customer);
        try {
            const response = yield fetch(url.toString());
            if (response.ok) {
                return (yield response.json()).ids;
            }
            else {
                return [];
            }
        }
        catch (e) {
            console.error(e);
            return [];
        }
    });
}
export const getCreativeIds = memoize(_getCreativeIds);
//# sourceMappingURL=RemoteAPI.js.map